import { PhotoModel } from '../types/protocols';
import { Userprofile } from './UsersContext';

/**
 * Resolve a photo uploader's display name from the loaded user list.
 * `photo.author` holds the uploader's Firebase UID (UID-only convention).
 * Returns null when the UID is missing or not found in the list.
 */
export const resolveUploaderName = (
    author: string | undefined,
    users: Userprofile[] | undefined
): string | null => {
    if (!author || !users) return null;
    return users.find(u => u.key === author)?.name || null;
};

/**
 * Build a Fancybox caption for a photo, combining uploader and date as
 * "Uppladdat av Uploader · YYYY-MM-DD hh:mm:ss". The "Uppladdat av" prefix
 * makes clear the person uploaded the photo, not necessarily took it. Falls
 * back to just the name or just the date when the other is unavailable (e.g.
 * user list still loading).
 */
export const buildPhotoCaption = (
    photo: PhotoModel,
    users: Userprofile[] | undefined
): string => {
    const name = resolveUploaderName(photo.author, users);
    const date = photo.date || '';
    const uploader = name ? `Uppladdat av ${name}` : '';
    if (uploader && date) return `${uploader} · ${date}`;
    return uploader || date || '';
};
